var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import faIcons from "@nexthink/apollo-tokens/lib/fa-icons";
import styled from "styled-components";
import { ThemeContext } from "../../theme/ThemeProvider";
// so that we can use its classname on other styled components
export const StyledIcon = styled(FontAwesomeIcon).withConfig({ displayName: "StyledIcon_APC-7311-productShell", componentId: "sc-k4wmpf" })({});
const Icon = forwardRef(function Icon(_a, ref) {
    var { name, title } = _a, rest = __rest(_a, ["name", "title"]);
    const theme = useContext(ThemeContext);
    return (React.createElement(StyledIcon, Object.assign({ ref: ref, icon: faIcons[name], title: title, color: theme.colors.apolloColorTextPrimary, fixedWidth: true }, rest)));
});
export default Icon;
//# sourceMappingURL=Icon.js.map